module.exports = __webpack_public_path__ + "static/media/KMH_5381.8e6d8fbb.jpg";